// 导入所有模块的接口
import * as admin from './modules/admin'
import * as user from './modules/user'
import * as customer from './modules/customer'
import * as video from './modules/video'
import * as profiles from './modules/profiles'
import * as report from './modules/report'

// 统一导出
export default {
  admin,
  user,
  customer,
  video,
  profiles,
  report
}